import type { FunctionComponent } from "react"

import type { ProductListHandoffSection } from "@/features/feed/contract"
import type { FeedSectionProps } from "@/features/feed/sections/types"

// The catalogue door is route chrome, not editorial: only the route knows the
// catalogue's path and its real count. This section used to print an unfiltered
// infinite grid — a second copy of the catalogue above the route's own filtered
// one — and its authored query carries facet *handles*, which the search backend
// matches by id, so any count taken from it comes back zero. The route renders
// the door at the true end of the page; this renders nothing.
export const ProductListHandoffFeedSection: FunctionComponent<FeedSectionProps<ProductListHandoffSection>> = () => null
